import React from 'react';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faCheckSquare } from '@fortawesome/free-solid-svg-icons/faCheckSquare';
import { faMinusSquare } from '@fortawesome/free-solid-svg-icons/faMinusSquare';
import { faSquare } from '@fortawesome/free-regular-svg-icons/faSquare';

const Checkbox = ({
  onChange,
  value = false,
  canClear = false,
  children,
  className,
}) => {
  const filledIcon = canClear ? faMinusSquare : faCheckSquare;

  return (
    <span
      className={`position-relative ${className}`}
    >
      <FA icon={value ? filledIcon : faSquare} />
      {children}
      <a
        href="#"
        className="pos-abs-spill"
        onClick={(evt) => {
          evt.preventDefault();
          evt.stopPropagation();
          onChange(!value);
        }}
      ></a>
    </span>
  );
};

export default Checkbox;
